import usePartners from '../../Partners/_hooks/usePartners';
import { REQUIRED_PARTNER_FIELDS } from '@/utils/user/REQUIRED_FIELDS';
import { partnerResponses as projectPartnerResponses } from '@/pages/dashboard-year/Projects/_projectInvitationDeclineReasons';
import { partnerResponses as eventPartnerResponses } from '@/pages/dashboard-year/Events/_invitationDeclineReasons';

export default function usePartnersEngagingWithEducators(network, timestamp) {
  return usePartners(network, undefined, timestamp.end, {
    ...REQUIRED_PARTNER_FIELDS,
    inactive: false
  }, undefined, [
    {
      type: 'count',
      alias: 'numberOfOffers',
      relation: 'offers',
      $where: {
        createdAt: {
          $gte: timestamp.start,
          $lte: timestamp.end
        }
      }
    },
    {
      type: 'count',
      alias: 'numberOfProjectInvitationsResponded',
      relation: 'questions',
      $where: {
        createdAt: {
          $gte: timestamp.start,
          $lte: timestamp.end
        },
        $or: [{
          response: 'Connect'
        }].concat(projectPartnerResponses.map(function(response) {
          return {
            response: 'Decline',
            responseMessage: {
              $ilike: `%${response}%`
            }
          }
        }))
      }
    },
    {
      type: 'count',
      alias: 'numberOfEventInvitationsResponded',
      relation: 'invitations',
      $where: {
        createdAt: {
          $gte: timestamp.start,
          $lte: timestamp.end
        },
        $or: [
          {
            response: 'Yes'
          },
          {
            response: 'Maybe'
          }
        ].concat(eventPartnerResponses.map(function(response) {
          return {
            response: 'No',
            responseMessage: {
              $ilike: `%${response}%`
            }
          }
        }))
      }
    }
  ], {
    $or: [
      {
        numberOfOffers: {
          $gte: 1
        }
      },
      {
        numberOfProjectInvitationsResponded: {
          $gte: 1
        }
      },
      {
        numberOfEventInvitationsResponded: {
          $gte: 1
        }
      }
    ]
  });
}
